<template>
  <div>
    <el-row :gutter="20" class="operation" style="padding:0 20px;">
      <el-tabs v-model="activeNameTabs" type="card" @tab-click="handleClick">
        <el-tab-pane label="品牌" name="brand" :style="{height: tableHeight+'px'}">
          <el-table
            ref="multipleTable"
            :data="brandOperationTable"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            :max-height="tableHeight"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            border
          >
            <el-table-column prop="createDate" label="操作时间">
              <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
            </el-table-column>
            <el-table-column prop="createUser" label="操作人"></el-table-column>
            <el-table-column prop="optContent" show-overflow-tooltip label="日志"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="系列" name="series" class="brandSeries">
          <el-table
            ref="multipleTable"
            :data="seriesOperationTable"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            :max-height="tableHeight"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            border
          >
            <el-table-column prop="createDate" label="操作时间">
              <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
            </el-table-column>
            <el-table-column prop="createUser" label="操作人"></el-table-column>
            <el-table-column prop="optContent" show-overflow-tooltip label="日志"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane
          label="单品"
          name="proModel"
          class="brandSeries"
          :style="{height: tableHeight+'px'}"
          v-if="this.$route.path === '/product/priceStrategy/coefficientAdjustment'"
        >
          <el-table
            ref="multipleTable"
            :data="seriesOperationTable"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            :max-height="tableHeight"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            border
          >
            <el-table-column prop="createDate" label="操作时间">
              <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
            </el-table-column>
            <el-table-column prop="createUser" label="操作人"></el-table-column>
            <el-table-column prop="optContent" show-overflow-tooltip label="日志"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <!-------------- 分页 -------------->
      <div class="pagination" style="margin-top:20px;">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import { queryPageAllOperation } from '@/api/system/rightsManagement'
import { formatDate } from '@/util/tool'
export default {
  name: 'OperationLog',
  components: { pagination },
  data () {
    return {
      activeNameTabs: 'brand',
      brandOperationTable: [],
      seriesOperationTable: [],
      total: 0,
      currentPage: 1,
      pageSize: 30,
      loadingTable: false,
      tableHeight: window.innerHeight - 320

    }
  },
  methods: {
    handleClick (tab) {
      this.activeNameTabs = tab.name
      this.currentPage = 1
      this.getList() // 切换tabs初始化操作日志列表
    },
    // 获取系列操作日志
    getList () {
      // 品牌操作日志
      this.loadingTable = true
      if (this.$route.path === '/product/priceStrategy/coefficientAdjustment') {
        // 系数调整的操作日志列表请求
        if (this.activeNameTabs === 'series') {
          // 系列操作日志
          this.getOperationList('brand_series_coefficient_manager')
        } else if (this.activeNameTabs === 'brand') {
          // 品牌操作日志
          this.getOperationList('brand_coefficient_manager')
        } else if (this.activeNameTabs === 'proModel') {
          // 型号操作日志
          this.getOperationList('product_coefficient_manager')
        }
      } else if (
        this.$route.path === '/product/productManage/productBrandSeries'
      ) {
        if (this.activeNameTabs === 'series') {
          this.getOperationList('brand_series_manager')
        } else if (this.activeNameTabs === 'brand') {
          this.getOperationList('brand_manager')
        }
      }
    },
    // 根据params类型调用操作日志接口
    getOperationList (params) {
      queryPageAllOperation(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.brandOperationTable = res.data.obj.records
            this.seriesOperationTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.operation .el-tabs--card {
  padding-top: 20px;
}
</style>
